module.exports = __webpack_public_path__ + "static/media/4.34ac6d07.jpg";